/**
 * Parse out the layout and hash for the given storyboard URL
 * @param {String} url  The URL to test
 * @return {Object|null}
 * @property {String} layout  The layout type like columnar, presentation
 * @property {String} hash  The private board hash or sha1 public hash
 * @property {String} access  Either 'public' or 'private' depending on hash type
 */
export default function parseStoryBoardUrl(url) {
	// regular board URL: /core/board/scrolling/abcdefg...
	// from angular:      /hub#/post/123/detail?sbHash=scrolling-abcdefg...
	// maybe future page: /core/somewhere?sbHash=scrolling-abcdefg...
	const match = url.match(/(?:\/board\/|[?&]sbHash=)([^/]+)(?:\/|-)((p?)[a-zA-Z0-9]+)/);
	if (!match) {
		return null;
	}
	return {
		layout: match[1],
		hash: match[2],
		access: match[3] === 'p' ? 'private' : 'public',
	};
}
